<template>
  <BaseLayout>
    <BaseDashboard :is-loading="isLoading">
      <div
        class="page-header bg-secondary m-0 p-3 border-bottom"
      >
        <h1
          class="page-title"
          v-if="getCampaignName!==''"
        >
          Campaign showcase - {{ getCampaignName }}
        </h1>
        <div class="page-options d-flex">
          <b-btn
            v-if="isSharer"
            class="btn btn-secondary btn-sm mr-3"
            data-test="showcase-share-button"
            v-b-modal.modalSharing
            v-b-tooltip.hover
            title="Share a showcase of your creative and content with third parties"
            :disabled="noSharedItems"
          >
            Share
            <i class="fal fa-share-square ml-2" />
          </b-btn>
        </div>
      </div>
      <div class="content-wrapper">
        <ContentShowcase
          view-type="Showcase"
          :read-only="readOnly"
          :start-index="this.startIndex"
          ref="contentShowcase"
        />
      </div>
    </BaseDashboard>
    <ShareModal
      :campaign="campaignSet"
      :share-type="'SHOWCASE'"
      v-if="isSharer"
    />
    <b-modal
      id="NoSharedItemsModal"
      title="Warning"
      size="sm"
      ok-only
    >
      This showcase has no shared items.
      Users who you have shared this with will no longer be able to preview your creative.
    </b-modal>
  </BaseLayout>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import * as types from '@/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';
import * as shareTypes from '@/modules/share/store/types';

import ContentShowcase from '@/modules/showcase/components/ContentShowcase';
import ShareModal from '@/modules/share/components/ShareModal';

export default {
  name: 'Showcase',
  components: {
    ContentShowcase,
    ShareModal,
  },
  data() {
    return {
      isLoading: false,
      startIndex: 0,
      campaignSet: null,
      readOnly: ['creative-properties'],
    };
  },
  computed: {
    ...mapState('content', [
      'mode',
      'creative',
      'feedId',
      'sharedCount',
      'activeCreatives',
    ]),
    ...mapState('account', [
      'shareeCount',
    ]),
    noSharedItems() {
      return this.sharedCount === 0;
    },
    getCampaignName() {
      if (!this.campaignSet) return '';
      return this.campaignSet.name;
    },
    isSharer() {
      return this.mode === 'SHARER';
    },
  },
  watch: {
    sharedCount(newValue) {
      if (newValue === 0 && this.shareeCount > 0) {
        this.$root.$emit('bv::show::modal', 'NoSharedItemsModal');
      }
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.RESET_CAMPAIGN,
      campaignTypes.GET_CAMPAIGN_BY_ID,
      campaignTypes.FETCH_ORDER,
    ]),
    ...mapActions('content', [
      contentTypes.FETCH_CREATIVE_BY_KEY,
      contentTypes.FETCH_EXISTING_CREATIVES_AS_SHAREE,
      contentTypes.FETCH_FEED_CONTENT_ITEMS,
      contentTypes.FETCH_FEED_CONTENT_ITEMS_BY_ID,
      contentTypes.UPDATE_CURRENT_SELECTED_CREATIVE_ID,
    ]),
    ...mapActions('share', [
      shareTypes.FETCH_SHARE_WITH_EMAILS_LIST,
    ]),
    ...mapMutations('content', [
      contentTypes.SET_CURRENT_PAGE,
      contentTypes.SET_CONTENT_LIST_TYPE,
      contentTypes.SET_SELECTED_CREATIVE_ID,
      contentTypes.SET_CREATIVE,
    ]),
    ...mapMutations('campaigns', [
      campaignTypes.SET_SELECTED_ADVERTISER,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    async handleCreate() {
      this.isLoading = true;
      this.RESET_CAMPAIGN();
      const { creativeKey, selectedItem } = this.$route.query;
      const { campaignId } = this.$route.params;
      const currentPage = parseInt(this.$route.query.currentPage, 10) || 1;
      this.SET_SELECTED_ADVERTISER(currentPage);
      this.SET_CONTENT_LIST_TYPE('SHOWCASE');
      try {
        await this.GET_CAMPAIGN_BY_ID(campaignId)
          .then((campaignSet) => {
            this.campaignSet = { id: campaignId, ...campaignSet };
          });
        const orderPayload = {
          advertiserId: this.campaignSet.advertiserId,
          campaignId,
          setOrder: true,
        };
        await this.FETCH_ORDER(orderPayload);
        await this.FETCH_EXISTING_CREATIVES_AS_SHAREE(campaignId);

        let selectedCreative;

        if (creativeKey) {
          selectedCreative = this.activeCreatives.find(((creative) => creative.creativeKey === creativeKey));
          this.startIndex = this.activeCreatives.findIndex(((creative) => creative.creativeKey === creativeKey));
          if (!selectedCreative) {
            this.SET_GLOBAL_MESSAGE({
              message: 'Creative is no longer available for showcase',
              type: 'warning',
            });
            setTimeout(() => {
              this.$router.push('/dashboard');
            }, 1000);
          }
        } else {
          selectedCreative = this.activeCreatives[0];
          this.startIndex = 0;
        }

        if (this.mode === 'SHARE') {
          await this.FETCH_SHARE_WITH_EMAILS_LIST({ creativeId: selectedCreative.id });
        }
        this.SET_SELECTED_CREATIVE_ID(selectedCreative.id);
        this.SET_CREATIVE(selectedCreative);

        if (selectedItem) {
          await this.FETCH_FEED_CONTENT_ITEMS_BY_ID(
            {
              feedId: selectedCreative.feedId,
              contentItemId: selectedItem,
            },
          );
        } else {
          await this.FETCH_FEED_CONTENT_ITEMS(selectedCreative.feedId);
        }
        this.isLoading = false;
      } catch (err) {
        // this.$router.back();
      }
    },
  },
  created() {
    this.handleCreate();
  },
};
</script>
<style>
.content-wrapper{
  height: calc(100% - 65px);
}
.comment-wrapper{
  height: calc(100% - 56px)!important;
}
</style>
